var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sidebar',{attrs:{"data":_vm.data,"logo-src":_vm.logo,"logo-icon-src":_vm.logoIcon}})}
var staticRenderFns = []

export { render, staticRenderFns }